import React, { useState } from 'react';

import { IStorytellingFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { Box } from '../Box';
import RichText from '../RichText';
import { Collapsible } from '../Collapsible';

import { ImageWrapper, StyledImage } from './styles';
import cx from 'classnames';

interface Props extends IStorytellingFields {
  sysId?: string;
}

export function Storytelling({
  backgroundColor,
  roundedImageOption,
  headingText,
  image,
  // In Contentful, "left" is mapped to true and "right" is vice versa.
  imageOrientation = true,
  collapsibles,
  button,
  images,
  sysId,
  anchorLink
}: Props) {
  const [currentImageIndex, setCurrentImageIndex] = useState(-1);

  const toggleCollapsible = (index: number) => {
    if (currentImageIndex === index) {
      setCurrentImageIndex(-1);
    } else {
      setCurrentImageIndex(index);
    }
  };

  return (
    <>
      <div
        className={cx('block-container', {
          'py-5 tablet:py-10 desktop:py-15': backgroundColor
        })}
        data-blockid="storytelling"
        data-testid="storytelling"
        id={anchorLink ?? `${sysId}`}
      >
        <div
          className={cx('layout flex-col gap-y-10', {
            'tablet:flex-row': imageOrientation,
            'tablet:flex-row-reverse': !imageOrientation
          })}
          data-testid="storytelling-layout"
          style={{
            backgroundColor: backgroundColor ?? 'transparent',
            alignItems: 'normal'
          }}
        >
          <div className="column w-full justify-center tablet:w-1/2 tablet:pr-3 desktop:pr-4">
            <div className="relative w-full">
              <StyledImage
                {...getImageData(image)}
                currentImage={images ? currentImageIndex === -1 : true}
                className={cx('', {
                  'rounded-3xl tablet:rounded-4xl': roundedImageOption
                })}
              />
            </div>
            {images &&
              images.map((img, index: number) => (
                <ImageWrapper key={index}>
                  <StyledImage
                    {...getImageData(img)}
                    currentImage={currentImageIndex === index}
                    className={cx('', {
                      'rounded-3xl tablet:rounded-4xl': roundedImageOption
                    })}
                  />
                </ImageWrapper>
              ))}
          </div>
          <div className="column tablet:grow-1 w-full justify-center tablet:mt-0 tablet:w-1/2 tablet:pl-3 desktop:grow-0 desktop:pl-4">
            <div className="border-box tablet:grow-1 w-[480px]">
              <div className="pb-8">
                <div className="heading-2">{headingText}</div>
              </div>
              <Box margin={{ 0: [0, 0, 'xl', 0] }}>
                {collapsibles &&
                  collapsibles.map(({ fields }, index: number) => {
                    return (
                      fields && (
                        <Collapsible
                          {...fields}
                          key={index}
                          isOpen={currentImageIndex === index}
                          onClick={() => toggleCollapsible(index)}
                        />
                      )
                    );
                  })}
              </Box>
              {button && (
                <div className="mt-10">
                  <RichText data={button} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
